import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Logo from '../assets/images/light-logo.png';

function Footer() {
    return (
        <footer className="">
            <Container>
                {/* --- FIX: Added text-center & text-lg-start to center content on mobile --- */}
                <Row className="align-items-center text-center text-lg-start">

                    {/* --- FIX: Changed 'md' to 'lg' to stack better on tablets --- */}
                    <Col lg={3} className="mb-3 mb-lg-0">
                        <div className='footer-logo'>
                            <img src={Logo} alt="Thamesbank Insurance Services Logo" />
                        </div>
                    </Col>

                    {/* --- FIX: Changed 'md' to 'lg' --- */}
                    <Col lg={5} className="mb-3 mb-lg-0">
                        <p className='mb-0'>
                            Thamesbank Insurance Services, Myinsurer.co.uk, Homeinsurer.co.uk, Tradeinsurer.co.uk, Quoteyourhome.co.uk, Driveinsurance.co.uk, and Quoteyourmotor.com are trading styles of Paragon Car Limited. Paragon Car Limited is authorised and regulated by the Financial Conduct Authority, firm reference number 312028.
                        </p>
                    </Col>

                    {/* --- FIX: Changed 'md' to 'lg' --- */}
                    <Col lg={4}>
                        <div className='footer-right'>
                            <p className='mb-0'>
                                <b>Registered office:</b> <br />
                                Jupiter House, Orbital One, Green Street Green Road, Dartford, Kent DA1 1QG. Registered in England and Wales. <br />
                                <b className='mt-2 d-block'>Company number:</b><span>04133312</span>
                            </p>
                        </div>
                    </Col>

                    <Col md={12}>
                        <p className="text-center mb-0 copyright-text">
                            &copy; {new Date().getFullYear()} Thamesbank Insurance Services. All rights reserved.
                        </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;